import { AuthenticationService } from "./authenticationService";
import appSetting from "@/appSetting";

export class RequestOptionsService {
  public static getTokenOptions() {
    return {
      method: "POST",
      url: `${appSetting.abacusCoreApiBaseUrl}/token`,
      headers: {
        "Content-Type": "application/json",
        Authorization: `ApiKey ${appSetting.apiKey}`
      },
      body: `{username: "${appSetting.tokenUser.username}", Company: "${appSetting.tokenUser.company}"}`
    };
  }

  public static putBrearerOptions(method, requestBody) {
    const token = AuthenticationService.readToken();
    return {
      method: "PUT",
      url: `${appSetting.abacusCoreApiBaseUrl}/${method}`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json"
      },
      body: requestBody,
      json: true
    };
  }

  public static postBrearerOptions(method, requestBody) {
    const token = AuthenticationService.readToken();
    return {
      method: "POST",
      url: `${appSetting.abacusCoreApiBaseUrl}/${method}`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json"
      },
      body: requestBody,
      json: true
    };
  }

  public static getBrearerOptions(route) {
    const token = AuthenticationService.readToken();
    return {
      method: "GET",
      url: `${appSetting.abacusCoreApiBaseUrl}/${route}`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json"
      },
      json: true
    };
  }
}
